import { deleteComment, flagComment } from 'lib/api/community_api';
import { Comment } from 'types/comment';
import styles from './CommentMenuButton.module.css';

type props = {
  isOwner: boolean;
  comment: Comment;
};

export default function CommentMenuButton(props: props) {
  return (
    <div className={styles.CommentMenuButton}>
      <span className="material-icons">more_vert</span>
      <div className={styles.CommentHoverTarget}></div>
      <div className={styles.CommentMenu}>
        <button
          onClick={() =>
            flagComment(props.comment.commentId, props.comment.communityPostId)
          }
        >
          Flag
          <Shape />
        </button>
        {props.isOwner && (
          <button
            onClick={() =>
              deleteComment(
                props.comment.commentId,
                props.comment.communityPostId
              )
            }
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
const Shape = () => (
  <svg
    width="22"
    height="10"
    viewBox="116 0 22 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M159 19V159C159 163.971 154.971 168 150 168H10C5.02944 168 1 163.971 1 159V19C1 14.0294 5.02944 10 10 10H115.343C116.669 10 117.941 9.47322 118.879 8.53553L124.879 2.53553C126.05 1.36396 127.95 1.36396 129.121 2.53553L135.121 8.53553C136.059 9.47322 137.331 10 138.657 10H150C154.971 10 159 14.0294 159 19Z"
      stroke="#0b0b0b"
      strokeWidth="2"
    />
  </svg>
);
